/*
 * @Date: 2021-3-23 14:39:51
 * @Author: WZ
 * @Description: 
 */
import CryptoJS from 'crypto-js' // 加密 or 解密

const secretKey = "ZniHsGZunPD43fKx"

export const AESUtil = {
  /**
   * AES加密方法
   * @param content 要加密的字符串
   * @returns {string} 加密结果
   */
  aesEncrypt: (content) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const srcs = CryptoJS.enc.Utf8.parse(content);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  /**
   * 解密方法
   * @param encryptStr 密文
   * @returns {string} 明文
   */
  aesDecrypt: (encryptStr) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypt = CryptoJS.AES.decrypt(encryptStr, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
}
/**
 * @description 格式化JSON源码(对象转换为JSON文本,是否为压缩模式)
 */
export const formatJSON = (txt, compress/*是否为压缩模式*/) => {
  const indentChar = '    '   
  if (/^\s*$/.test(txt)) {   
    console.log('数据为空,无法格式化! ')   
    return
  }   
  try {
    var data=eval('('+txt+')')
  } catch(e) {   
    console.log('数据源语法错误,格式化失败! 错误信息: '+e.description,'err');   
    return
  }
 let draw = []
 const line = compress ? '' : '\n'
 var nodeCount = 0, maxDepth = 0 /* eslint-disable */ // eslint-disable-line no-unused-vars
 const notify = (name, value, isLast, indent, formObj) => {   
    nodeCount++
    for (var i = 0, tab = ''; i < indent; i++)tab += indentChar //缩进HTML
    tab = compress ? '' : tab /*压缩模式忽略缩进*/
    maxDepth=++indent /*缩进递增并记录*/  
    if(value&&value.constructor==Array){ /*处理数组*/
        draw.push(tab+(formObj?('"'+name+'":'):'')+'['+line) // 缩进'[' 然后换行
        for (var i=0;i<value.length;i++)
            notify(i,value[i],i==value.length-1,indent,false)
        draw.push(tab+']'+(isLast?line:(','+line)));/*缩进']'换行,若非尾元素则添加逗号*/  
    }else   if(value&&typeof value=='object'){/*处理对象*/  
            draw.push(tab+(formObj?('"'+name+'":'):'')+'{'+line);/*缩进'{' 然后换行*/  
            var len=0,i=0;   
            for(var key in value)len++;   
            for(var key in value)notify(key,value[key],++i==len,indent,true);   
            draw.push(tab+'}'+(isLast?line:(','+line)));/*缩进'}'换行,若非尾元素则添加逗号*/  
        }else{   
                if(typeof value=='string')value='"'+value+'"';   
                draw.push(tab+(formObj?('"'+name+'":'):'')+value+(isLast?'':',')+line);   
        }
 } 
 const isLast = true
 const indent = 0
 notify('',data,isLast,indent,false);   
 return draw.join('');   
}